export default "__VITE_ASSET__5uMd5HJ1__"